import React from 'react';
import './index.css';

export default class Score extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      score:0,
      updateScoreInt:null
    }
    this.updateScore = this.updateScore.bind(this)
  }

  updateScore () {
    this.setState({score: this.state.score + 1})
    this.props.getScore(this.state.score)
  }

  componentDidMount(){
    //this.setState({updateScoreInt:setInterval(this.updateScore,100)})
  }

  componentWillUnmount() {
    //clearInterval(this.state.updateScoreInt)
  }

  componentDidUpdate(prevProps){
    if (prevProps.jumpCount === 0 && this.props.jumpCount === 1) {
      this.setState({updateScoreInt:setInterval(this.updateScore,100)})
    }
    if(!this.props.playing) {
        //console.log('dead...')
        clearInterval(this.state.updateScoreInt)

        //this.state.obstacle.style.webkitAnimationPlayState = "paused";
    }
  }

  render() {
    return (
        <h2 id='score'>Score: {this.state.score}</h2>   
    )
  }
}



